<template>
  <div class="public-content epay-trade">
    <div class="breadcrumb">扣款明细</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="100px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交易状态:">
              <el-select v-model="formInline.tradeStatus" clearable placeholder="请选择">
                <el-option v-for="(v, k) in $config.deductTradeStatus" :key="k" :label="v" :value="k">
                </el-option>
                <!-- <el-option label="已扣款" value="PAID"></el-option> -->
                <!-- <el-option label="未扣款" value="UNPAID"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="支付方式:">
              <el-select v-model="formInline.paymentType" clearable placeholder="请选择">
                <el-option label="全部" value="">全部</el-option>
                <el-option v-for="(v, k) in $config.paymentTypes" :key="k" :label="v" :value="k">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="申请日期:">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button round @click="onSubmit(1)">查询</el-button>
            <el-button round @click="exportExcel()">导出Excel</el-button>
            <el-button round type="primary" v-if="$hasPermission('epay:admin:deduct:add')" @click="applyFor()">申请扣款</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="流水号" fixed="left" prop="serialNo" min-width="210">
            <template slot-scope="scope">
              <span class="color-blue" @click="toExamine(scope.row)">{{ scope.row.serialNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="金额" prop="amount" min-width="100"></el-table-column>
          <el-table-column label="申请日期" prop="dateCreated" min-width="180"></el-table-column>
          <el-table-column label="支付方式" prop="paymentType">
            <template slot-scope="scope"> {{ $config.paymentTypes[scope.row.paymentType] }} </template>
          </el-table-column>
          <el-table-column label="支付日期" prop="dateAudited" min-width="180"></el-table-column>
          <el-table-column label="支付状态" prop="paymentStatus" min-width="100">
            <template slot-scope="scope"> {{ $config.paymentStatus[scope.row.paymentStatus] }} </template>
          </el-table-column>
          <el-table-column label="交易状态" prop="tradeStatus" min-width="100">
            <template slot-scope="scope"> {{ $config.deductTradeStatus[scope.row.tradeStatus] }} </template>
          </el-table-column>
          <el-table-column label="平台号" prop="store.code" min-width="130"></el-table-column>
          <el-table-column label="平台名称" prop="store.name" min-width="130"></el-table-column>
          <el-table-column label="业务" prop="store.salesman.fullName" min-width="130"></el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage" />
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { adminDeductPage, adminVpayDeductExport } from '@/api/epay'
import { storeQueryListByCode, storeQueryListByName, getSalesmanByFullName } from '@/api/crm'

export default {
  components: {
    VPagination
  },
  data () {
    return {
      deleteDialog: false,
      salemanList: [],
      storeListByCode: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      formInline: {
        dateEnd: '2999-01-28',
        dateStart: '2021-12-28',
        // outTradeNo: '',
        paymentStatus: '',
        salesmanId: '',
        // serialNo: '',
        paymentType: '',
        storeId: '',
        code: ''
        // tradeStatus: '',
        // tradeType: ''
      },
      value2: [
        this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      tableData: [],
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      rateTypeList: []
    }
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        if (val) {
          this.formInline.dateStart = val[0]
          this.formInline.dateEnd = val[1]
        } else {
          this.formInline.dateStart = ''
          this.formInline.dateEnd = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
      this.salemanList = JSON.parse(sessionStorage.getItem('salemanList'))
      this.value2 = [this.formInline.dateStart, this.formInline.dateEnd]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('storeListByCode')
      sessionStorage.removeItem('salemanList')
    }
    this.onSubmit()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    applyFor () {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      this.$router.push('/epay/deduct/apply')
    },
    toExamine (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      this.$router.push({ path: '/epay/deduct/audit', query: { id: row.orderId } })
    },
    onSubmit (num) {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      }
      this.queryInfo.pageNum = num || this.queryInfo.pageNum
      adminDeductPage({
        data: Object.fromEntries(Object.entries(this.formInline).map(([key, value]) => [key, value === '' ? null : value])),
        params: {
          page: this.queryInfo.pageNum - 1,
          size: this.queryInfo.pageSize
        }
      })
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.content
            this.queryInfo.total = res.data.data.total
          }
        })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    },
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      adminVpayDeductExport(this.formInline).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          // let _fileName = '扣款明细表' + this.$moment(new Date()).format('YYMMDDhmmss') + '.xls'
          let _fileName = '扣款明细表' + this.formInline.dateStart + '-' + this.formInline.dateEnd + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
@deep: ~">>>";

@{deep} .data-list .el-table tr td {
  height: 40px !important;
  padding: 0 !important;
}
</style>
